import { render, staticRenderFns } from "./DialogComprovante.vue?vue&type=template&id=4770443f&scoped=true&lang=pug"
import script from "./DialogComprovante.vue?vue&type=script&lang=js"
export * from "./DialogComprovante.vue?vue&type=script&lang=js"
import style0 from "./DialogComprovante.vue?vue&type=style&index=0&id=4770443f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4770443f",
  null
  
)

export default component.exports